
import "@/assets/fullVideoComponent.css"
import { VideoInfo } from "@/models/VideoInfo"
import VideoPlayer from "@/components/shared/Player.vue"
import IframeVideoPlayer from "@/components/shared/IframeVideoPlayer.vue"
import { SubtitleUrls } from "@/models/captions/SubtitleUrls"
import { defineComponent, PropType } from "vue"
import { VideoType } from "@/models/VideoType"

export default defineComponent({
  components: { VideoPlayer, IframeVideoPlayer },
  props: {
    fullvideo: Object as PropType<VideoInfo>,
    showHead: Boolean,
    duration: String,
    subtitleUrls: Object as PropType<SubtitleUrls>,
    subtitles: Array as PropType<Array<SubtitleUrls>>
  },
  setup() {
    return { VideoType }
  }
})
